import { RouteConfig } from 'vue-router';
import * as handlers from '../handlers';

const routes: Array<RouteConfig> = [
  {
    path: '1',
    name: 'mdt-tool-value',
    component: () => import('@/pages/quote/forms/toolsAndEquipment/pages/ToolsAndEquipmentToolValue.vue'),
    meta: {
      back: handlers.dashboard
    }
  },
  {
    path: '2',
    name: 'mdt-claims',
    component: () => import('@/pages/quote/forms/toolsAndEquipment/pages/ToolsAndEquipmentClaims.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'mdt-tool-value', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '3',
    name: 'mdt-specified-items',
    component: () => import('@/pages/quote/forms/toolsAndEquipment/pages/ToolsAndEquipmentSpecifiedItems.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'mdt-claims', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
  {
    path: '4',
    name: 'mdt-client-events',
    component: () => import('@/pages/quote/forms/general/ClientEventsPage.vue'),
    meta: {
      back(this: Vue): string {
        return this.$router.resolve({ name: 'mdt-specified-items', params: { packageHash: this.$packageHash } }).href;
      }
    }
  },
];

export default routes;
